import useSWR from 'swr';
import { fetcher } from './api';
import { API } from '../constants';
import { SWR_CONFIG } from './config';
import { ProfileResponse } from '../types';

export const useProfile = () => {
  const { data, isLoading, error } = useSWR<ProfileResponse>(API.PROFILE, fetcher, SWR_CONFIG);

  return { profile: data, isLoading, error };
};
